import { render, staticRenderFns } from "./InstitutionAiConfiguration.vue?vue&type=template&id=7d49c1f8&scoped=true&"
import script from "./InstitutionAiConfiguration.vue?vue&type=script&lang=js&"
export * from "./InstitutionAiConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionAiConfiguration.vue?vue&type=style&index=0&id=7d49c1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d49c1f8",
  null
  
)

export default component.exports